import React, { useContext, useEffect } from "react";
import OrderOverview from "../../components/order-overview/OrderOverview";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../../util/context";
import { inactiveState } from "../../util/inactivity";

export default function OrderOverviewPage() {
  const ctx = useContext(CartContext);
  const navigate = useNavigate();

  window.onload = function () {
    inactiveState(ctx, navigate);
  };

  useEffect(() => {
    if (!ctx.isLoggedIn) {
      navigate("/login");
    }
  }, [ctx]);

  return <OrderOverview />;
}
